import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import {
	Router,
	Event,
	NavigationStart,
	NavigationEnd,
	NavigationError,
	NavigationCancel,
} from '@angular/router';
import { CanonicalService } from './services/canonical.service';

@Component({
	selector: 'app-root',
	standalone: true,
	imports: [CommonModule, RouterOutlet],
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
	title = 'Short Solutions';
	loading = true;

	constructor(
		private canonicalService: CanonicalService,
		private router: Router
	) {}

	ngOnInit(): void {
		this.router.events.subscribe((e: Event) => {
			if (e instanceof NavigationStart) this.loading = true;
			if (
				e instanceof NavigationEnd ||
				e instanceof NavigationCancel ||
				e instanceof NavigationError
			) {
				this.loading = false;
			}
		});
		// CanonicalService automatically sets canonical URL on route changes
	}
}
